/*eslint-disable*/
import React from "react";

// reactstrap components
import {Button, Container } from "reactstrap";
// core components

import { Link } from "react-router-dom";

function IndexHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div className="page-header clear-filter" filter-color="red">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/header.jpg").default + ")",
          }}
          ref={pageHeader}
        ></div>
        <Container>
          <div className="content-center brand">
            <img
              alt="..."
              className="n-logo"
              src={require("assets/img/xpatso.png").default}
            ></img>
            <h1 className="h1-seo">XPATSO</h1>
            <h3>For Hassle free Expats Life.</h3>

            <a href="https://apps.apple.com/in/app/xpatso/id1592275631" target="_blank">
                <img
                  alt="iOS App"
                  className="img-raised img-badge img-ios-badge"
                  src={require("assets/img/App_Store_Badge.svg").default}
                ></img>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.justus.xpatso" target="_blank">
                <img
                  alt="Android App"
                  className="img-raised img-badge"
                  src={require("assets/img/google-play-badge.png").default}
                ></img>
              </a>
          </div>
          <h6 className="category category-absolute">
          Available for Indians in Uruguay
          </h6>
        </Container>
      </div>
    </>
  );
}

export default IndexHeader;
